export const getActivityDurationCopy = (duration) => {
    if(duration < 60) {
        return `${duration}min`;
    } else {
        const hours = Math.floor(duration / 60);
        const remainingMinutes = duration % 60;
        // Minuti con zero-padding (es. "1h05") per evitare l'ambiguità di "1h5".
        return `${hours}h${remainingMinutes > 0 ? `${String(remainingMinutes).padStart(2, '0')}` : ''}`;
    }
}